module.exports = __webpack_public_path__ + "img/logoCentradoLinealBLANCO.cff3c85a.png";